import { Spacer } from 'foundations-components/components/Spacer';
import { View } from 'foundations-components/components/View';
import { PricePerMonth } from 'pricing-pages-ui-components/price/PricePerMonth';
import { getShowDiscountedCopy } from 'pricing-pages-ui-components/utils/priceUtils';
import { FullPriceContainerBlockLarge, PriceContainer, StartsAtMicroCopy } from './PriceStyledComponents';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/**
 * This component is used to display a price in a given currency styled for the pricing page merch cards.
 */

export const PriceDisplayStyled = ({
  pricingInfo,
  showPricePerMonthPerSeat = false,
  seleniumId,
  currencyCode,
  currencyCodeUnit
}) => {
  const showDiscountedCopy = getShowDiscountedCopy({
    pricingInfo
  });
  const {
    monthly: {
      calculatedPrice: monthlyCalculatedPrice
    },
    offerInfo
  } = pricingInfo;
  const isAnnualPaymentTerm = (offerInfo === null || offerInfo === void 0 ? void 0 : offerInfo.payment) === 'annual';
  if (showDiscountedCopy || isAnnualPaymentTerm) {
    return /*#__PURE__*/_jsxs(View, {
      textAlign: "left",
      children: [StartsAtMicroCopy, /*#__PURE__*/_jsx(PriceContainer, {
        children: /*#__PURE__*/_jsx(FullPriceContainerBlockLarge, {
          children: /*#__PURE__*/_jsx(PricePerMonth, {
            price: monthlyCalculatedPrice,
            showPricePerMonthPerSeat: showPricePerMonthPerSeat,
            seleniumId: seleniumId,
            currencyCode: currencyCode,
            currencyCodeUnit: currencyCodeUnit
          })
        })
      })]
    });
  }
  return /*#__PURE__*/_jsxs(View, {
    textAlign: "left",
    children: [/*#__PURE__*/_jsx(Spacer, {
      space: "600"
    }), /*#__PURE__*/_jsx(FullPriceContainerBlockLarge, {
      children: /*#__PURE__*/_jsx(PricePerMonth, {
        price: monthlyCalculatedPrice,
        currencyCode: currencyCode,
        seleniumId: seleniumId,
        showPricePerMonthPerSeat: showPricePerMonthPerSeat,
        currencyCodeUnit: currencyCodeUnit
      })
    })]
  });
};